import { types } from './actions';

const initialState = {
  isGeometricAttributesModalOpen: false,
  isUpdatingGeometricAttributes: false,
  geometricAttributesModalComponentId: null,
  geometricAttributesModalPart: null,
};

const reducer = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case types.GEOMETRIC_ATTRIBUTES_MODAL_OPEN:
      return {
        ...state,
        isGeometricAttributesModalOpen: true,
        geometricAttributesModalPart: payload.part,
        geometricAttributesModalComponentId: payload.componentId,
      };
    case types.GEOMETRIC_ATTRIBUTES_MODAL_CLOSE:
      return {
        ...state,
        isGeometricAttributesModalOpen: false,
        geometricAttributesModalPart: null,
        geometricAttributesModalComponentId: null,
      };
    case types.UPDATE_GEOMETRIC_ATTRIBUTES_REQUEST:
      return {
        ...state,
        isUpdatingGeometricAttributes: true,
      };
    case types.UPDATE_GEOMETRIC_ATTRIBUTES_SUCCESS:
      return {
        ...state,
        isGeometricAttributesModalOpen: false,
        isUpdatingGeometricAttributes: false,
      };
    case types.UPDATE_GEOMETRIC_ATTRIBUTES_ERROR:
      return {
        ...state,
        isUpdatingGeometricAttributes: false,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.quotes.geometricAttributesModal;

export const getIsGeometricAttributesModalOpen = (state) =>
  getScope(state).isGeometricAttributesModalOpen;

export const getIsUpdatingGeometricAttributes = (state) =>
  getScope(state).isUpdatingGeometricAttributes;

export const getGeometricAttributesModalComponentId = (state) =>
  getScope(state).geometricAttributesModalComponentId;

export const getGeometricAttributesModalPart = (state) =>
  getScope(state).geometricAttributesModalPart;
